// extracted by mini-css-extract-plugin
export default {"cls1":"MaskedDescription-MaskedValue_cls1__IH1px","cls2":"MaskedDescription-MaskedValue_cls2__cYqAh MaskedDescription-MaskedValue_cls1__IH1px"};